'use strict';

var SystemConfigurationPanelController = function SystemConfigurationPanelController($scope, SystemConstants) {
  $scope.mode = null;
  $scope.$on('system-configuration:modeChanged', function (event, mode) {
    $scope.mode = mode;
  });
  $scope.isSystemParameterScreen = function () {
    return $scope.mode === SystemConstants.SCREEN_VALUE.SYSTEM_CONFIG.SYSTEM_PARAMETER;
  };
  $scope.isLinkedFbcScreen = function () {
    return $scope.mode === SystemConstants.SCREEN_VALUE.SYSTEM_CONFIG.LINKED_FBC;
  };
  $scope.isFareBuilderScreen = function () {
    return $scope.mode === SystemConstants.SCREEN_VALUE.SYSTEM_CONFIG.FARE_BUILDER;
  };
  $scope.isMarketClassFareScreen = function () {
    return $scope.mode === SystemConstants.SCREEN_VALUE.SYSTEM_CONFIG.MARKET_CLASS_FARE;
  };
  $scope.isBudgetTargetScreen = function () {
    return $scope.mode === SystemConstants.SCREEN_VALUE.SYSTEM_CONFIG.BUDGET_TARGET;
  };
  $scope.isMarketAssignScreen = function () {
    return $scope.mode === SystemConstants.SCREEN_VALUE.SYSTEM_CONFIG.MARKET_ASSIGN;
  };
  $scope.isFlightAssignmentScreen = function () {
    return $scope.mode === SystemConstants.SCREEN_VALUE.SYSTEM_CONFIG.FLIGHT_ASSIGNMENT;
  };
  $scope.isLegAssignmentScreen = function () {
    return $scope.mode === SystemConstants.SCREEN_VALUE.SYSTEM_CONFIG.LEG_ASSIGNMENT;
  };
  $scope.isEntityScreen = function () {
    return $scope.mode === SystemConstants.SCREEN_VALUE.SYSTEM_CONFIG.ENTITY;
  };
  $scope.isHostShareScreen = function () {
    return $scope.mode === SystemConstants.SCREEN_VALUE.SYSTEM_CONFIG.HOST_SHARE;
  };
  $scope.isEventsScreen = function () {
    return $scope.mode === SystemConstants.SCREEN_VALUE.SYSTEM_CONFIG.EVENTS;
  };
  $scope.isFlightTagScreen = function () {
    return $scope.mode === SystemConstants.SCREEN_VALUE.SYSTEM_CONFIG.FLIGHT_TAG;
  };
  $scope.isDiscontinuedRoutesScreen = function () {
    return $scope.mode === SystemConstants.SCREEN_VALUE.SYSTEM_CONFIG.DISCONTINUED_ROUTES;
  };
  $scope.isUserDefinedRefDataScreen = function () {
    return $scope.mode === SystemConstants.SCREEN_VALUE.SYSTEM_CONFIG.USER_DEFINED_REF_DATA;
  };
  $scope.isWebFareScreen = function () {
    return $scope.mode === SystemConstants.SCREEN_VALUE.SYSTEM_CONFIG.WEB_FARE;
  };
  $scope.isSurchargeUpload = function () {
    return $scope.mode === SystemConstants.SCREEN_VALUE.SYSTEM_CONFIG.SURCHARGE_UPLOAD;
  };
  $scope.isMarketClassFareInfluencesScreen = function () {
    return $scope.mode === SystemConstants.SCREEN_VALUE.SYSTEM_CONFIG.MARKET_CLASS_FARE_INFLUENCES;
  };
  $scope.$on('$stateChangeSuccess', function (event, toState, toParams) {
    $scope.$broadcast('configuration-host-share:navigation-from-global');
  });
};
SystemConfigurationPanelController.$inject = ['$scope', 'SystemConstants'];
module.exports = SystemConfigurationPanelController;